<template>
  <div class="full">
    <div class="full">
      <header-campaigns
        :header-title="$t('CAMPAIGN_FLOW.TITLE')"
        @handle-tab="handleTab"
        @enable-card-new-campaign="enableCardNewCampaign"
      />
    </div>
    <div class="container-campaign">
      <list-contacts-view v-if="tab == 'list'"/>
      <campaign-view v-else :isNewCampaign="isNewCampaign" @enable-card-new-campaign="enableCardNewCampaign"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import campaignMixin from 'shared/mixins/campaignMixin';
import HeaderCampaigns from './Header.vue';
import ListContactsView from './ListContactsView.vue';
import CampaignView from './CampaignView.vue';

export default {
  components: {
    HeaderCampaigns,
    ListContactsView,
    CampaignView
  },
  mixins: [campaignMixin],
  data() {
    return {
      tab: '',
      isNewCampaign: true
    };
  },
  computed: {
    buttonText() {
      return this.$t('CAMPAIGN_FLOW.HEADER.BUTTON_ADD') + this.tab;
    },

    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    }),
  },
  methods: {
    enableCardNewCampaign(isNewCampaign){
      this.closeCampaignSelect()
      this.isNewCampaign = isNewCampaign;
    },
    closeCampaignSelect(){
      this.$store.dispatch('campaignsFlow/setCampaign', { campaign: null });
    },
    handleTab(tab){
      this.tab = tab;
      if(tab === 'list'){
        this.getContactsList();
        return;
      }
      this.getContactsList();
      this.getCampaignsFlow();
    },
    async getContactsList(){
      await this.$store.dispatch('campaignsContactList/get');
    },
    async getCampaignsFlow(){
      await this.$store.dispatch('campaignsFlow/get');
    },
  },
};
</script>

<style scoped>
.contacts-page, .full {
  width: 100%;
  overflow: auto;
}
.container-campaign{
  overflow: auto;
}
</style>
